<template>
  <div>
    <v-select
      outlined
      v-model="rates"
      :items="state.items"
      item-text="name"
      item-value="id"
      :menu-props="{ maxHeight: '400', zIndex: 13 }"
      label="Nb de votes"
    ></v-select>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "RatesFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const state = reactive({
      dishes: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const rates = computed({
      get: () => store.getters["marmiton/getRates"],
      set(e) {
        store.dispatch("marmiton/updateRates", e);
      },
    });

    // =>  WATCH
    watch(rates, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        // is_multiple: false,
        is_integer: true,
        // is_boolean: false,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      const { data } = await axiosGet("/regie/marmiton/rates");
      set(state, "items", data);

      await synchronizeFilterWithQueryString({
        dispatcher: "marmiton/updateRates",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: rates.value,
        // is_multiple: false,
        is_integer: true,
        // is_boolean: false,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      state,
      rates,
    };
  },
};
</script>

<style></style>
